import token from 'stores/token';
import userStore from 'stores/user';

export const validate = async (tokenData) => {
	try {
		const res = await fetch('/api/auth/validate', {
			method: 'GET',
			headers: { 'x-access-token': tokenData },
		});
		const response = await res.json();
		userStore.set({
			isLoggedIn: !!response.data ?? false,
			...response.data,
		});
		token.set(response.token);
	} catch (error) {
		console.error(error);
	}
};
